// AI agent endpoints. The base URL already carries the `/admin` prefix
// (same convention as SystemEndpoints `/system/modules`), so paths here
// are written without it.
export const AgentEndpoints = {
  chat: '/agent/chat',
  chatStream: '/agent/chat/stream',
  conversations: '/agent/conversations',
  conversationMessages: (conversationId: string) => `/agent/conversations/${conversationId}/messages`,
};
